<!-- Vue js Radial Progress Bar
Ejemplo en web, con cada propiedad a modificar: https://wyzantinc.github.io/vue-radial-progress/
Documentación de npm: https://www.npmjs.com/package/vue-radial-progress
 -->
 <template>
	<div class="d-flex cont-item-circular justify-center align-center">
    <div class="text-center text-xs-center"  >
        <radial-progress-bar 
          :class="cmpClassBarra"
          :diameter="80" :completed-steps="value" 
          :total-steps="progresoTotal" 
          :startColor="'#33BA8A'"
          :stopColor="'#33BAdE'"
          :innerStrokeColor="'#EFF0F5'" 
          :innerStrokeWidth="8"
          :strokeWidth="8"
          >
          <div class="fondo"><p> {{progresoActual}}</p></div>
        </radial-progress-bar>
    </div>
    <div class="cont-texto ma-2">
      <p class="ma-0"> {{titulo}}</p>
      <v-btn class="mt-1" color="btncolor" dark x-small @click="Filtrar">Filtrar</v-btn>  
    </div>
	</div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
export default {
  props: {
    progresoActual: {
      type: Number,
      default: 0
    },
    progresoTotal: {
      type: Number,
      default: 100
    },
    titulo: {
      type: String,
      default: ''
    },
    idEvento: {
      type: String,
      default: ''
    }
  },
  components: {
      RadialProgressBar
  },
  data() {
    return {
      interval: {},
      value: 0,
      bFiltrando: false
    }
  },
  beforeDestroy() {
      clearInterval(this.interval)
  },
  mounted() {
      // this.interval = setInterval(() => {
      //     if (this.value === 100) {
      //         return (this.value = 0)
      //     }
      //     this.value += 10
      // }, 1400)
    setTimeout(() => {
        this.value = this.progresoActual
    }, 300);
  },
  methods: {
    Filtrar () {
      this.$emit('filtrar', !this.bFiltrando ? this.idEvento : this.idEvento*-1)
      this.bFiltrando =! this.bFiltrando
    }
  },
  watch:{
    progresoActual(){
      this.value = this.progresoActual
    }
  },
  computed: {
    cmpClassBarra() {
      return this.bFiltrando ? 'Seleccionado' : 'barra'
    }
  },
    
}
</script>

<style lang="scss" scoped>
.cont-item-circular{
  width: 250px;
  padding: 10px;
}

.barra {
    border-radius: 50%;
    box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.3);
}
.fondo{
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  p{
    text-align: center;
    color: #273348;
    font-size: 22px!important;
    margin: 0px;
    padding: 0px;
  }
}
.Seleccionado{
  border-radius: 50%;
  box-shadow: 0px 0px 10px 2px rgba($color: #4CAF50, $alpha: 1);
}
.cont-texto{
  width: 100%;
  white-space: normal;
  p{
    font-size: 0.9em;
    line-height: 1em;
  }
}
</style>